var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #667085;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.24,14.43c.36-.36.84-.56,1.35-.56s.99.2,1.35.56l7.63,7.63c.36.36.56.84.56,1.35s-.2.99-.56,1.35l-24.81,24.81c-.36.36-.84.56-1.35.56h-7.63c-.51,0-.99-.2-1.35-.56-.36-.36-.56-.84-.56-1.35v-7.63c0-.51.2-.99.56-1.35l19.08-19.08,5.72-5.72Zm-4.38,9.77l-17.17,17.17v4.93h4.93l17.17-17.17-4.93-4.93Zm7.63,2.24l3.03-3.03-4.93-4.93-3.03,3.03,4.93,4.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.82c31e2e53b60f9d7d2634d6428527d2.svg";
export { ForwardRef as ReactComponent };